<template>

	<!-- Stars -->
	<div class="review__rating-box box__rating-box" v-if="reviewCount !== undefined && reviewCount !== 0">
		<div class="review__rating-stars" v-if="reviewCount !== 0 && reviewCount !== undefined">
			<stars :value="stars" :disabled="true"></stars>
		</div>

		<div class="review_date box__review-date">{{reviewCount | reviewCase}}</div>
	</div>
	<!-- Stars End -->

</template>

<script>
	import Stars from './Stars.vue'

	export default {
		name: "UserRating",
		components: {Stars},
		props: ['stars', 'reviewCount']
	}
</script>
<style></style>



// WEBPACK FOOTER //
// Rating.vue?547bfcaa